import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { connect } from 'react-redux';
import { withRenderFlag } from '@beef/react';
import { compose } from '@beef/utils';
import classNames from 'classnames/bind';
import { ContentHeader } from "../../../../common/ContentHeader";
import { buildOrderQueryParams, getOrderTariffInlineTexts, selectAlternativeTariffData, shouldShowAlternativeTariffBlock } from "../../../../../store/selectors";
import { SubscriptionCard } from "../SubscriptionCard";
import styles from "./styles.pcss";
var cn = classNames.bind(styles);
var _AlternativeTariffBlock = function _AlternativeTariffBlock(_ref) {
  var data = _ref.data,
    alternativeTariffTitle = _ref.alternativeTariffTitle,
    detailsUrl = _ref.detailsUrl;
  return /*#__PURE__*/React.createElement("div", {
    className: cn('container'),
    "data-t-id": "components-AlternativeTariffBlock"
  }, /*#__PURE__*/React.createElement(ContentHeader, {
    title: alternativeTariffTitle
  }), /*#__PURE__*/React.createElement(SubscriptionCard, _extends({}, data, {
    detailsUrl: detailsUrl
  })));
};
var mapStateToProps = function mapStateToProps(state) {
  var _getOrderTariffInline;
  var urlParams = buildOrderQueryParams(state);
  var data = selectAlternativeTariffData(state);
  var detailsUrl = "".concat(data.detailsUrl, "?").concat(urlParams);
  return {
    data: data,
    detailsUrl: detailsUrl,
    alternativeTariffTitle: (_getOrderTariffInline = getOrderTariffInlineTexts(state)) === null || _getOrderTariffInline === void 0 ? void 0 : _getOrderTariffInline.alternativeTariffTitle,
    shouldRender: shouldShowAlternativeTariffBlock(state)
  };
};
var connector = connect(mapStateToProps);
export var AlternativeTariffBlock = compose(connector, withRenderFlag)(_AlternativeTariffBlock);